<template>
  <div class="technology-admin">
    <div class="tabs">
        <div class="tab-item" v-for="(item,index) in menuList" :key="item.name" @click="changeTab(index)" :style="{color:index == current?'#008585':'#f7f7f7'}">
            {{item.label}}
        </div>
    </div>
    <div class="components-content">
        <component :is="componentName"/>
    </div>
  </div>
</template>
<script>
import addComponent from './pages/addComponents.vue';
import cateComponent from './pages/cateComponents.vue';
export default {
    components:{
        addComponent,
        cateComponent
    },
    data(){
        return {
            current:0,
            componentName:'addComponent',
            tabPosition:'left',
            menuList:[
                {
                    label: '添加组件',
                    name: 'addComponent'
                },{
                    label:'组件分类',
                    name:'cateComponent'
                }
            ]
        }
    },
   
    created(){
        console.log(1111111)
    },
    methods:{
        changeTab(index){
            this.current = index
            this.componentName = this.menuList[index].name;
        }
    }
};
</script>
<style lang="scss" scoped>
.technology-admin{
    height: 100vh;
    background-color: #212121;
    padding: 10px;
    display: flex;
    .tabs{
        flex: 1;
        border-right: 1px solid #f7f7f7;
        box-sizing: border-box;
    }
    .components-content{
        flex: 9;
        padding: 15px;
        box-sizing: border-box;
    }
    .tab-item{
        color: #f7f7f7;
        padding: 10px;
        border-bottom: 1px solid #333;
        &:hover{
            color: #008585;
            cursor: pointer;
        }
    }
}
</style>